import { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';

const manageAccountRouteKey = {
  detail: 'detail',
  setPassword: 'set-password',
};

/**
 * A hook to provide block/unblock flow inner route
 * @param url Current url of the page
 * @returns
 */
export const useManageRoute = (url: string) => {
  const history = useHistory();
  const [step, setStep] = useState(0);

  const toStep1 = useCallback(() => {
    setStep(0);
    history.push(`${url}/${manageAccountRouteKey.detail}`);
  }, [history, url]);

  const toStep2 = useCallback(
    (data: any) => {
      setStep(1);
      history.push(`${url}/${manageAccountRouteKey.setPassword}`, { accountData: data });
    },
    [history, url]
  );

  return {
    step,
    localRouteKey: manageAccountRouteKey,
    toStep1,
    toStep2,
  };
};
